import { render, staticRenderFns } from "./r-radio-group.vue?vue&type=template&id=8a8731f2"
import script from "./r-radio-group.vue?vue&type=script&lang=js"
export * from "./r-radio-group.vue?vue&type=script&lang=js"
import style0 from "./r-radio-group.vue?vue&type=style&index=0&id=8a8731f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports